import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Moneyowed.css';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    practice: [],
    tags: [],
    filter: '',
    accounts: '',
    format: '',
    include_closed: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);

      setFormData((prevState) => ({
        ...prevState,
        [name]: selectedOptions,
      }));
    } else if (type === 'checkbox') {
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="mo-wrap">
      <h2 className="mo-title">Parameters</h2>

      <form onSubmit={handleSubmit} className="mo-panel">
        {/* Accounts */}
        <div className="mo-row">
          <label
            className="mo-label"
            htmlFor="practice"
            title="Please choose an account to limit the report to"
          >
            Accounts
          </label>
          <div className="mo-field">
            <select
              id="practice"
              name="practice"
              value={formData.practice}
              onChange={handleChange}
              className="mo-select"
            >
              <option value="">Select accounts</option>
              <option value="144545">2ingis s.a.</option>
              <option value="105255">Whyte house Dental Surgery</option>
            </select>

            <label className="mo-check" htmlFor="include_closed">
              <input
                type="checkbox"
                id="include_closed"
                name="include_closed"
                checked={formData.include_closed}
                onChange={handleChange}
              />
              Include Closed
            </label>
          </div>
        </div>

        {/* Account Tags */}
        <div className="mo-row">
          <label className="mo-label" htmlFor="tags" title="Select tags to filter report">
            Account Tags
          </label>
          <div className="mo-field">
            <select
              id="tags"
              name="tags"
              value={formData.tags}
              onChange={handleChange}
              className="mo-select"
            >
              <option value="">No filter</option>
              <option value="a-practices">a-practices</option>
              <option value="bhandal">bhandal</option>
              <option value="coventry-dental">coventry-dental</option>
              <option value="deborderntal-beauty">dental-beauty</option>
              <option value="murray-dental-">murray-dental-</option>
              <option value="swissmeda">swissmeda</option>
            </select>
          </div>
        </div>

        {/* Filter */}
        <div className="mo-row">
          <label className="mo-label" htmlFor="filter" title="Please choose a filter to limit the report">
            Filter
          </label>
          <div className="mo-field">
            <select
              id="filter"
              name="filter"
              value={formData.filter}
              onChange={handleChange}
              className="mo-select mo-wide"
            >
              <option value="">Live Totals</option>
              <option value="overdue">Live Totals - Overdue Only</option>
              <option value="statements">Last Statement</option>
            </select>
          </div>
        </div>

        {/* Conditional Accounts Selection */}
        {formData.filter === 'statements' && (
          <div className="mo-row">
            <label
              className="mo-label"
              htmlFor="accounts"
              title="Please choose which accounts to limit the report"
            >
              Accounts
            </label>
            <div className="mo-field">
              <select
                id="accounts"
                name="accounts"
                value={formData.accounts}
                onChange={handleChange}
                className="mo-select mo-wide"
              >
                <option value="had_balance">Had Balance As Of Last Statement</option>
                <option value="">Balance Or Activity Since Statement</option>
                <option value="has_balance">Currently Has A Balance</option>
                <option value="all">Don't Filter Statements</option>
              </select>
            </div>
          </div>
        )}

        {/* Format */}
        <div className="mo-row">
          <label className="mo-label" htmlFor="format" title="Please choose a display format">
            Format <span className="mo-req">*</span>
          </label>
          <div className="mo-field">
            <select
              id="format"
              name="format"
              value={formData.format}
              onChange={handleChange}
              required
              className="mo-select mo-wide"
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </select>
          </div>
        </div>

        {/* Run Button */}
        <div className="mo-row">
          <span className="mo-label" />
          <div className="mo-field">
            <Link to="/Addturntime" className="mo-link">
              <button id="pay-per-task-submit" type="button" className="mo-run">
                <FaSearch /> Run
              </button>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ReportForm;